import React, { useContext, useEffect, useRef } from "react";
import { Home } from "./pages/Home";
import { StoreContext } from "./store/Store";
import { GlobalRefContext } from "./store/GlobalRefs";
import { actionTypes } from "./store/storeTypes";
import { ControlPopupMenu } from "./components/ControlPopupMenu";
import { Tooltip } from "./components/Tooltip";
import { TitlePopup } from "./components/TitlePopup";
import Auth from "./services/auth";
import { getBoxPositions } from "./utils/renderFunctions";

const authServ = new Auth();

function App() {
  const [store, dispatch] = useContext(StoreContext);
  const grefs = useContext(GlobalRefContext);
  const scrollThrottleRef = useRef(null);

  const { auth, scrollTop } = store;

  useEffect(() => {
    if (window.__hideInitialLoader__) {
      window.__hideInitialLoader__();
    }
  }, []);

  useEffect(() => {
    grefs.controlPositions.current = getBoxPositions(
      grefs,
      "controlRefs",
      scrollTop
    );
    grefs.titlePositions.current = getBoxPositions(
      grefs,
      "titleRefs",
      scrollTop
    );
  }, [scrollTop, grefs]);

  useEffect(() => {
    authServ.login("anonymous@vecviz.com", "P@ssword321");

    // console.log('window.reactPress',window.reactPress)

    // If ingognito then flag it for reload
    if (Object.keys(localStorage).length === 0) {
      dispatch({ type: actionTypes.SET_INGOGNITO, payload: true });
    }

    dispatch({ type: actionTypes.SET_AUTH, payload: authServ });
  }, [dispatch]);

  useEffect(() => {
    if (auth) {
      const box = grefs.appRef.current.getBoundingClientRect();
      dispatch({
        type: actionTypes.SET_DIMENSIONS,
        payload: { vh: box.height, navHeight: 0, vw: box.width },
      });
    }
  }, [dispatch, grefs.appRef, auth]);

  const onScroll = (e) => {
    const currentScrollTop = e.currentTarget.scrollTop;
    if (scrollThrottleRef.current) return;

    scrollThrottleRef.current = requestAnimationFrame(() => {
      scrollThrottleRef.current = null;
      dispatch({
        type: actionTypes.SET_SCROLLTOP,
        payload: currentScrollTop,
      });
    });
  };

  return auth ? (
    <div
      onScroll={(e) => onScroll(e)}
      ref={grefs.appRef}
      style={{
        height: "100vh",
        width: "100vw",
        overflowX: "undefined",
        overflowY: "scroll",
        backgroundColor: "#ffffff",
      }}
    >
      <ControlPopupMenu />
      <Tooltip />
      <TitlePopup />
      <Home />
    </div>
  ) : null;
}

export default App;
